import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-827cdd92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eg-container" }
const _hoisted_2 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Language = _resolveComponent("Language")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'main' } }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            link: _ctx.link,
            text: this.$store.state.language === 'fr' ? 'accueil' : 'home',
            mainColor: "var(--colorPrimary)",
            hoverColor: "var(--colorPrimaryDark)"
          }, null, 8, ["link", "text"])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: { name: 'schedule', params: { type: 'type', id: 'id' } } }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            link: _ctx.link,
            text: 
            this.$store.state.language === 'fr' ? 'Programmation' : 'Schedule'
          ,
            mainColor: "var(--colorPrimary)",
            hoverColor: "var(--colorPrimaryDark)",
            stateMenuNumber: _ctx.stateMenuNumber,
            stateMenuFilter: _ctx.stateMenuFilter,
            stateMenuMenu: _ctx.stateMenuMenu
          }, null, 8, ["link", "text", "stateMenuNumber", "stateMenuFilter", "stateMenuMenu"])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Language)
  ]))
}